module.exports = __webpack_public_path__ + "img/logo.737203b4.png";